import { ICheckboxControl } from '@infotech-soe/metaschema';

import { TActionArgsValues } from '../../../../infrastructure/providers/abstract/IApiProvider';
import {
  CheckboxFormControlViewModel,
  FormControlViewModelType,
  LocalizedProps,
} from '../../view-model/FormControlViewModel';
import { FormSource, FormSourceType } from '../../view-model/FormSource';

import { getValueFromArgsOrConfig } from './helpers';

const buildCheckboxControl = async (
  item: ICheckboxControl,
  localizedProps: LocalizedProps,
  args: TActionArgsValues,
  source: FormSource
): Promise<CheckboxFormControlViewModel> => {
  const value = getValueFromArgsOrConfig<boolean | string | number | null>(
    item,
    args,
    source,
    item.allowNull ? null : false
  );

  return {
    value:
      item.allowNull && value === null
        ? null
        : value === true || value === 'Y' || value === 1,
    columns: item.columns,
    ...localizedProps,
    name: item.name,
    type: FormControlViewModelType.CHECKBOX,
    disabled: item.disabled,
    noLabel: item.noLabel,
    required: !item.allowNull,
    storeValue: item.storeValue,
    readonly: item.readonly || source.type === FormSourceType.REVIEW,
    hasValue: true,
    hasHistory: false,
    visible: item.visible,
    padTop: item.padTop,
    allowNull: item.allowNull,
  };
};

export default buildCheckboxControl;
